// Default template for Customer Journey Map data structure

export const emptyJourney = {
  metadata: {
    project_name: '',
    created_at: null,
    updated_at: null,
    wizard_version: '2.0.0'
  },
  problems: [
    {
      statement: '',
      cost_amount: '',
      cost_justification: '',
      tam_amount: '',
      tam_justification: '',
      current_solutions_fail: '',
      market_opportunity: '',
      expected_moat: '',
      solutions: [] // Features/solutions for this specific problem
    }
  ],
  product_statement: '', // General product statement
  persona: {
    name: '',
    role: ''
  },
  // General features (not problem-specific)
  features: [
    { name: '', value: '', evidence: '' },
    { name: '', value: '', evidence: '' },
    { name: '', value: '', evidence: '' }
  ],
  story_arc: {
    hero: '',
    quest: '',
    villains: '',
    guide: '',
    moment_of_truth: '',
    success: ''
  },
  stages: [
    { name: 'Awareness', action: '', thoughts: '', feeling: '' },
    { name: 'Consideration', action: '', thoughts: '', feeling: '' },
    { name: 'Trial', action: '', thoughts: '', feeling: '' },
    { name: 'Purchase', action: '', thoughts: '', feeling: '' },
    { name: 'Onboarding', action: '', thoughts: '', feeling: '' },
    { name: 'Adoption', action: '', thoughts: '', feeling: '' },
    { name: 'Advocacy', action: '', thoughts: '', feeling: '' }
  ]
};

export const createNewJourney = (projectName) => ({
  ...emptyJourney,
  metadata: {
    ...emptyJourney.metadata,
    project_name: projectName,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
});
